import { useMutation } from '@apollo/client';
import { CHANGE_DATE_REQUEST_STATUS } from '../../../constants/ChangeDateRequestConstants';
import SAVE_CHANGE_DATE_REQUEST from '../../../queries/ChangeDateRequest/saveChangeDateRequestMutation';
import REVIEW_CHANGE_DATE_REQUEST from '../../../queries/ChangeDateRequest/reviewChangeDateRequestMutation';
import CalendarEventMapper from '../../../mappers/CalendarEventMapper';
import moment from 'moment';
import { showSuccessToast } from '@shared/services/toastService';

const STATUS_TO_MESSAGE_MAP = new Map([
  [CHANGE_DATE_REQUEST_STATUS.APPROVED, 'approved'],
  [CHANGE_DATE_REQUEST_STATUS.DECLINED, 'declined']
]);

const useDateChangeRequest = (eventId, changeDateRequestData, setEventFormData) => {
  const [saveChangeDateRequest, { error: saveChangeDateRequestError }] =
    useMutation(SAVE_CHANGE_DATE_REQUEST);

  const [reviewChangeDateRequest, { error: reviewChangeDateRequestError }] = useMutation(
    REVIEW_CHANGE_DATE_REQUEST
  );

  const handleSubmitDataRequest = async requestData => {
    const { data } = await saveChangeDateRequest({
      variables: {
        requestData: CalendarEventMapper.toApolloChangeDateRequestInput(requestData, eventId)
      }
    });

    showSuccessToast('Change request has been submitted successfully.');
    updateEventFormData(data.saveChangeDateRequest.StartDate, data.saveChangeDateRequest.EndDate);
  };

  const handleChangeDateRequestReviewed = async (status, declineComment) => {
    const { data } = await reviewChangeDateRequest({
      variables: {
        requestData: CalendarEventMapper.toApolloReviewChangeDateRequestInput(
          changeDateRequestData.Id,
          eventId,
          status,
          declineComment
        )
      }
    });

    showSuccessToast(`Appraisal dates ${STATUS_TO_MESSAGE_MAP.get(status)} successfully.`);
    updateEventFormData(
      data.reviewChangeDateRequest.StartDate,
      data.reviewChangeDateRequest.EndDate,
      data.reviewChangeDateRequest.EventAssignments
    );
  };

  const updateEventFormData = (startDate, endDate, eventAssignments) => {
    if (!startDate || !endDate) return;

    setEventFormData(prevState => ({
      ...prevState,
      startDate: moment(startDate).toDate(),
      endDate: moment(endDate).toDate(),
      ...(eventAssignments && {
        eventAssignments: CalendarEventMapper.toEditAssignments(eventAssignments)
      })
    }));
  };

  return {
    dateChangeRequestError: saveChangeDateRequestError || reviewChangeDateRequestError,
    handleChangeDateRequestReviewed,
    handleSubmitDataRequest
  };
};

export default useDateChangeRequest;
